import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import 'survey-core/i18n/italian';
import { Model, settings } from 'survey-core';
import { FlatLightPanelless } from 'survey-core/themes';
import { marked } from 'marked';

import {
  MapPolygonQuestionComponent,
  registerMapPolygonQuestion,
} from './map-polygon-question/map-polygon-question.component';
import { registerPropertyTypologyQuestion } from './property-typology-question/property-typology-question.component';
import { registerRangeSelectQuestion } from './range-select-question/range-select-question.component';

@Component({
  selector: 'app-surveyjs-form',
  template: `<survey *ngIf="surveyModel" [model]="surveyModel"></survey>`,
})
export class SurveyJsFormComponent implements OnInit {
  @Input()
  surveyJson!: Record<string, unknown>;

  @Output()
  completion = new EventEmitter<{
    [key: string]: string[];
  }>();

  surveyModel?: Model;

  constructor() {
    settings.specialChoicesOrder.selectAllItem = [1];
    registerMapPolygonQuestion();
    registerRangeSelectQuestion();
    registerPropertyTypologyQuestion();
  }

  ngOnInit() {
    this.initSurveyModel();
  }

  private initSurveyModel() {
    const surveyModel = new Model(this.surveyJson);

    surveyModel.applyTheme({
      ...FlatLightPanelless,
      cssVariables: {
        ...FlatLightPanelless.cssVariables,
        '--sjs-primary-backcolor': 'var(--primary-color)',
        '--sjs-primary-backcolor-dark': 'var(--dark-color)',
        '--sjs-general-backcolor-dim': 'var(--white-color)',
        '--sd-mobile-width': '0px',
      },
    });
    surveyModel.locale = 'it';
    surveyModel.showCompletedPage = false;
    surveyModel.showCompleteButton = true;

    surveyModel.onTextMarkdown.add((_, options) => {
      let str = marked.parseInline(options.text, { async: false, gfm: true });
      options.html = str;
    });

    surveyModel.onComplete.add(sender => {
      this.completion.emit(sender.data);
    });

    this.surveyModel = surveyModel;
  }
}
